import { Typography } from '@design-system/components/typography/typography';
import { Switch } from '@mui/material';
import { Controller } from 'react-hook-form';
import { sprinkles } from '@design-system/sprinkles.css';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';

export type SubscriptionFreeTrialProps = Pick<
  SubscriptionBundlesVM['priceEditModal'],
  'control' | 'freeTrial'
>;

export const SubscriptionFreeTrial = ({
  control,
  freeTrial,
}: SubscriptionFreeTrialProps) => {
  return (
    <div className="flex flex-col gap-4">
      <Typography variant="body" size="small">
        7-DAY FREE TRIALS:
      </Typography>
      <div className="flex flex-col md:flex-row gap-4">
        <Controller
          name={'monthlyFreeTrial'}
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className="flex items-center gap-4">
              <Switch
                checked={value}
                onChange={onChange}
                color="primary"
                disabled={freeTrial.disabled.monthly}
                slotProps={{
                  input: {
                    name: 'monthly-free-trial',
                  },
                }}
              />
              <Typography
                variant="body"
                size="large"
                fontWeight="normal"
                className={sprinkles({
                  color: freeTrial.disabled.monthly ? 'N-60' : 'B-100',
                })}
              >
                monthly subscription
              </Typography>
            </div>
          )}
        />
        <Controller
          name={'annualFreeTrial'}
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className="flex items-center gap-4">
              <Switch
                checked={value}
                onChange={onChange}
                color="primary"
                disabled={freeTrial.disabled.annual}
                slotProps={{
                  input: {
                    name: 'annual-free-trial',
                  },
                }}
              />
              <Typography
                variant="body"
                size="large"
                fontWeight="normal"
                className={sprinkles({
                  color: freeTrial.disabled.annual ? 'N-60' : 'B-100',
                })}
              >
                annual subscription
              </Typography>
            </div>
          )}
        />
      </div>
    </div>
  );
};
